import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import useStyles from './pillCustomVibrantBlue.styles';
/* eslint no-tabs: ['error', { allowIndentationTabs: true }] */
const DEFAULT_ICON_SIZE = 44;
const PillCustomVibrantBlueSVG = (props) => {
	const {
		width,
		text,
        // iconSize,
        backgroundColor,
        fontColor,
        onTextMatrixChange,
	} = props;
	const textRef = useRef();
	const classes = useStyles({
		backgroundColor,
        fontColor,
	});
	const [transformMatrix, setTransformMatrix] = useState('matrix(1 0 0 1 115 28.5142)');

	useEffect(() => {
        onTextMatrixChange(transformMatrix);
    }, [transformMatrix]);

	useEffect(() => {
		if (textRef.current) {
			const text = textRef.current;
			const tbox = text.getBBox();
			const newX = (118 - tbox.width / 2);
			// const newY = ((iconSize - tbox.height) / 2);
			const translation = 'matrix(1 0 0 1 ' + newX + ' 28.5142)';
			setTransformMatrix(translation);
		}
	}, [textRef.current, width, text]);
	return (
		<svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px'
			viewBox='0 0 204 48' xmlSpace='preserve'>
			<g>

				<linearGradient id='SVGID_1_' gradientUnits='userSpaceOnUse' x1='7.599592e-07' y1='1584.0967' x2='183.497' y2='1584.0967' gradientTransform='matrix(1 0 0 -1 0 1608)'>
					<stop offset='0' style={{ 'stop-color': '#3A1860' }} />
					<stop offset='1' style={{ 'stop-color': '#0F0138' }} />
				</linearGradient>
				<path className={classes.st0} d='M23.62,47.4C10.87,47.4,0.5,36.86,0.5,23.9S10.87,0.4,23.62,0.4h156.77c12.75,0,23.12,10.54,23.12,23.5
		s-10.37,23.5-23.12,23.5H23.62z'/>
				{/* <path className={classes.st1} d='M180.38,0.9c12.47,0,22.62,10.32,22.62,23s-10.15,23-22.62,23H23.62C11.15,46.9,1,36.59,1,23.9
		s10.15-23,22.62-23H180.38 M180.38-0.1H23.62C10.57-0.1,0,10.65,0,23.9s10.57,24,23.62,24h156.77c13.04,0,23.62-10.75,23.62-24
		S193.43-0.1,180.38-0.1L180.38-0.1z'/> */}
			</g>
			{/* <circle className={classes.st2} cx='23.73' cy='23.9' r='20' /> */}
			<g transform='translate(10 12.3) scale(0.075)'>
				<defs>
					<linearGradient id='ecalLoadingGrad1' x1='99.12' y1='54.1' x2='426.64' y2='53.52' gradientUnits='userSpaceOnUse'>
						<stop offset='0' stopColor='#ff9e00' />
						<stop offset='1' stopColor='#ff4c00' />
					</linearGradient>
					<linearGradient id='ecalLoadingGrad2' x1='-19860.28' y1='54.12' x2='-19497.81' y2='53.48' gradientTransform='translate(11289.25 107.61) scale(0.56 -1)' gradientUnits='userSpaceOnUse'>
						<stop offset='0' stopColor='#ff9e00' />
						<stop offset='1' stopColor='#ffe000' />
					</linearGradient>
					<linearGradient id='ecalLoadingGrad3' x1='2.65' y1='161.67' x2='290.7' y2='161.16' gradientUnits='userSpaceOnUse'>
						<stop offset='0' stopColor='#00d7ff' />
						<stop offset='0.16' stopColor='#00c6ff' />
						<stop offset='1' stopColor='#0074ff' />
					</linearGradient>
					<linearGradient id='ecalLoadingGrad4' x1='51.86' y1='161.42' x2='257.92' y2='161.42' gradientTransform='translate(309.78 322.83) rotate(180)' gradientUnits='userSpaceOnUse'>
						<stop offset='0' stopColor='#00d6ff' />
						<stop offset='0.53' stopColor='#00d5a2' />
						<stop offset='1' stopColor='#00d54f' />
					</linearGradient>
					<linearGradient id='ecalLoadingGrad5' x1='44.77' y1='269.3' x2='376.03' y2='268.72' gradientUnits='userSpaceOnUse'>
						<stop offset='0' stopColor='#000084' />
						<stop offset='1' stopColor='#0074ff' />
					</linearGradient>
					<linearGradient id='ecalLoadingGrad6' x1='132.56' y1='269.01' x2='380.78' y2='269.01' gradientTransform='translate(513.34 538.02) rotate(-180)' gradientUnits='userSpaceOnUse'>
						<stop offset='0' stopColor='#0074ff' />
						<stop offset='1' stopColor='#000084' />
					</linearGradient>
				</defs>
				<rect style={{ fill: 'url(#ecalLoadingGrad1)' }} x='96.11' y='0' width='335.23' height='107.61' rx='53.81' ry='53.81' />
				<rect style={{ fill: 'url(#ecalLoadingGrad2)' }} x='180.23' y='0' width='207.49' height='107.61' rx='53.81' ry='53.81' transform='translate(567.94 107.61) rotate(180)' />
				<rect style={{ fill: 'url(#ecalLoadingGrad3)' }} x='0' y='107.61' width='294.83' height='107.61' rx='53.81' ry='53.81' />
				<rect style={{ fill: 'url(#ecalLoadingGrad4)' }} x='51.86' y='107.61' width='206.06' height='107.61' rx='53.81' ry='53.81' transform='translate(309.78 322.83) rotate(-180)' />
				<rect style={{ fill: 'url(#ecalLoadingGrad5)' }} x='41.72' y='215.2' width='339.05' height='107.61' rx='53.81' ry='53.81' />
				<rect style={{ fill: 'url(#ecalLoadingGrad6)' }} x='132.56' y='215.2' width='248.22' height='107.61' rx='53.81' ry='53.81' transform='translate(513.34 538.02) rotate(180)' />
			</g>
			<rect x='55.94' y='17.49' className={classes.st11} width='129.06' height='13.51' />
			<text ref={textRef} transform={transformMatrix} className={classNames([classes.st12, classes.st13, classes.st14])} >{props.text}</text>
		</svg>
	);
};

PillCustomVibrantBlueSVG.propTypes = {
	width: PropTypes.number,
	text: PropTypes.string,
	iconSize: PropTypes.number,
	onTextMatrixChange: PropTypes.func,
};

PillCustomVibrantBlueSVG.defaultProps = {
	width: 200,
	text: 'Sync to Calendar',
	iconSize: DEFAULT_ICON_SIZE,
	onTextMatrixChange: () => {},
};

export default PillCustomVibrantBlueSVG;
